import React from 'react'
import SearchSvg from 'images/modules/Shared/i-search.svg?raw'

export { default as SearchUrl } from 'images/modules/Shared/i-search.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: SearchSvg}} />
)
